import { STATUS, CATEGORIES, IMP_STATUS } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { useLang, statusLabel } from "@/lib/i18n";

export const StatusBadge = ({ status, className, testId }) => {
  const { t } = useLang();
  return (
    <span data-testid={testId || `status-badge-${status}`} className={cn("inline-flex items-center px-2 py-0.5 rounded text-[11px] font-semibold uppercase tracking-wide whitespace-nowrap", `st-${status || "no_data"}`, className)}>
      {STATUS[status] ? statusLabel(t, status) : status}
    </span>
  );
};

export const CategoryBadge = ({ category, costType, withName }) => (
  <span data-testid={`category-badge-${category}`} className={cn("inline-flex items-center justify-center min-w-[26px] px-1.5 py-0.5 rounded text-[11px] font-bold font-mono", CATEGORIES[category]?.cls)} title={CATEGORIES[category]?.name}>
    {category === "C" && costType ? costType : category}{withName ? ` · ${CATEGORIES[category]?.name}` : ""}
  </span>
);

export const ImpBadge = ({ status, reason, contFrom }) => (
  <span data-testid={`imp-status-${status}`} title={contFrom ? `Lanjutan Improvement Sheet YTD yang dibuka sejak ${contFrom}` : reason === "YTD" ? "Dipicu akumulasi YTD yang belum tercapai (bulan ini sendiri tercapai)" : reason === "bulanan" ? "Dipicu realisasi bulan ini yang tidak tercapai" : undefined}
    className={cn("inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-semibold uppercase tracking-wide", IMP_STATUS[status]?.cls, contFrom && "opacity-70 border border-dashed border-slate-400")}>
    {IMP_STATUS[status]?.label || status}{reason && <span className="font-normal normal-case opacity-70 text-[10px]">· {contFrom ? `lanjutan ${contFrom}` : reason === "YTD" ? "akumulasi YTD" : "bulan ini"}</span>}
  </span>
);

export const StatCard = ({ label, value, sub, accent, testId, icon: Icon }) => (
  <div data-testid={testId} className="card-flat p-4 flex flex-col gap-1 relative overflow-hidden fade-up">
    {accent && <span className="absolute left-0 top-0 bottom-0 w-1" style={{ background: accent }} />}
    <div className="flex items-center justify-between">
      <span className="label-caps">{label}</span>
      {Icon && <Icon size={14} className="text-slate-400" />}
    </div>
    <div className="text-2xl font-heading font-bold tabular text-slate-900">{value}</div>
    {sub && <div className="text-xs text-slate-500">{sub}</div>}
  </div>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-6 no-print">
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
      {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
    </div>
    {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
  </div>
);

export const AchBar = ({ value }) => {
  const v = value ?? 0;
  const st = value === null || value === undefined ? "no_data" : v >= 100 ? "advance" : v >= 90 ? "on_track" : v >= 80 ? "delay" : "not_achieve";
  return (
    <div className="flex items-center gap-2 min-w-[120px]">
      <div className="h-2 flex-1 bg-slate-100 rounded-sm overflow-hidden">
        <div className="h-full transition-[width] duration-500" style={{ width: `${Math.min(v, 120) / 1.2}%`, background: STATUS[st].color }} />
      </div>
      <span className="font-mono text-xs w-14 text-right">{value == null ? "-" : `${v.toFixed(1)}%`}</span>
    </div>
  );
};
